import { proxyCustomElement, HTMLElement, createEvent, h, Host } from '@stencil/core/internal/client';
import { i as input, l as label, b as inputInvalid, c as inputDisabled, d as inputFocused } from './parts.js';
import { F as FormControlErrorText } from './form-control-error-text.js';
import './details.js';
import { d as defineCustomElement$2 } from './custom-popper2.js';
import { d as defineCustomElement$1 } from './form-control-tooltip2.js';

const DateInput = /*@__PURE__*/ proxyCustomElement(class DateInput extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.formControlInput = createEvent(this, "formControlInput", 7);
        this.formControlBlur = createEvent(this, "formControlBlur", 7);
        this.isFocused = false;
        this.maxDate = this.currentDate;
        this.handleFormControlInput = (event) => {
            const dateValue = event.target.value;
            this.inputHandler(this.name, dateValue);
            this.formControlInput.emit({ name: this.name, value: dateValue });
        };
    }
    handleDefaultValueChange(newValue) {
        this.updateInput(newValue);
    }
    get currentDate() {
        if (!this.showTime) {
            return new Date().toISOString().split('T')[0];
        }
        else {
            return new Date().toISOString().slice(0, 16);
        }
    }
    componentDidLoad() {
        this.updateInput(this.defaultValue);
    }
    updateInput(value) {
        this.dateInput.value = value;
    }
    get part() {
        let part = input;
        if (this.errorText) {
            part = inputInvalid;
        }
        if (this.disabled) {
            part = inputDisabled;
        }
        if (this.isFocused) {
            part = inputFocused;
        }
        return part;
    }
    render() {
        return (h(Host, { key: '587ee2fa01634a32f985ab19aaf4f62d010ce10c' }, h("div", { key: '95958ed36ccb85a5a4d6c7db452e924c5000924c', class: "form-group d-flex flex-column" }, h("div", { key: 'ea8a18b68dcafb62c46543c0beea80321e67b990', class: "d-flex gap-2" }, h("label", { key: '78a4be7c16a0f1d6a6d02d5c6fd17ccc25d727f3', part: label, class: "form-label", htmlFor: this.name }, this.label), h("form-control-tooltip", { key: '85306bcf45e676a668f9a6b78deda4c5decc9831', helpText: this.helpText })), h("input", { key: '8526227900d9e9abc11635ffc8598c53c6db397a', type: this.showTime ? 'datetime-local' : 'date', ref: el => (this.dateInput = el), id: this.name, name: this.name, onFocus: () => this.isFocused = true, onBlur: () => {
                this.isFocused = false;
                this.formControlBlur.emit();
            }, onInput: this.handleFormControlInput, part: this.part, class: this.errorText ? 'form-control is-invalid' : 'form-control', disabled: this.disabled, max: this.maxDate }), h(FormControlErrorText, { key: '341c4283c126602dc25cd5beeec7c11b26e13b18', errorText: this.errorText, name: this.name }))));
    }
    static get watchers() { return {
        "defaultValue": ["handleDefaultValueChange"]
    }; }
}, [0, "form-control-date", {
        "name": [1],
        "label": [1],
        "inputHandler": [16, "input-handler"],
        "defaultValue": [1, "default-value"],
        "helpText": [1, "help-text"],
        "errorText": [1, "error-text"],
        "disabled": [4],
        "showTime": [4, "show-time"],
        "maxDate": [1, "max-date"],
        "isFocused": [32]
    }, undefined, {
        "defaultValue": ["handleDefaultValueChange"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["form-control-date", "custom-popper", "form-control-tooltip"];
    components.forEach(tagName => { switch (tagName) {
        case "form-control-date":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, DateInput);
            }
            break;
        case "custom-popper":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
        case "form-control-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$1();
            }
            break;
    } });
}
defineCustomElement();

export { DateInput as D, defineCustomElement as d };
